var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltipOptions),expression:"tooltipOptions"}],staticClass:"vuestic-tooltip-target"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }